import { Constants } from "../../public/scripts/diamond-api.min.js";

// DATA FOR AGENT MONITORING
export default {
    state: () => ({
      extension: "",
      agent: {},
      monitoringState: Constants.MonitoringState.NotConnected
    }),
    mutations: {
      setMonitoringState: (state, data) => state.monitoringState = data,
      setExtension: (state, data) => state.extension = data,
      setAgent: (state, data) => state.agent = data,
    },
    getters: {
      monitoringState: (state) => state.monitoringState,
      monitoringAgent: (state) => state.agent,
      monitoringExtension: (state) => state.extension
    }
  }